<a class="link">
    <img src="/assets/spbfamily/dl.svg" alt="Télécharger" height="25px"> &nbsp; <ng-content></ng-content>
</a>